import ListItem from '@material-ui/core/ListItem';
import { withStyles } from '@material-ui/core/styles';

const SecondaryNavItem = withStyles(() => ({
  gutters: {
    padding: '0',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}))(ListItem);

export default SecondaryNavItem;
